/**
 * Get questions and then append the subQuestions too.
 */

import { createSelector } from 'reselect';

import type { QuestionTreeItem } from '/business/shared/functions/types';
import getQuestions from './getQuestions';

export default createSelector(getQuestions, (questions) => {
  if (!questions || !Array.isArray(questions)) {
    return null;
  }
  let output: QuestionTreeItem[] = [...questions];
  questions.forEach((question) => {
    if (question.subQuestions) {
      output = [...output, ...question.subQuestions];
    }
  });

  return output.filter((item) => {
    return !item?.isSelectorPage;
  });
});
